import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../config.service';
import { Observable, throwError } from 'rxjs';
import { BarcodeParameter } from '../../models/client-models';

const BARCODE_ENDPOINT = 'barcode';

@Injectable({
  providedIn: 'root',
})
export class BarcodeBackendService {
  constructor(private http: HttpClient) {}

  sendBarcode(barcode: BarcodeParameter): Observable<any> {
    // Validation
    if (!barcode || !barcode.barcode || barcode.barcode.trim().length === 0) {
      return throwError(
        () => new Error('Invalid barcode: barcode is empty or null')
      );
    }

    let processedBarcode = barcode.barcode.trim();
    // Only check for real GS1 separators: (, ), ', ç - NOT %
    // % is part of the data in 1D barcodes (like %20 for operation)
    const hasGS1Chars = /[\(\)'\u00E7\u001D]/.test(processedBarcode);

    if (hasGS1Chars) {
      // Check for apostrophe ' which indicates barcode format (not QR)
      const hasApostrophe = processedBarcode.includes("'");

      // Split by GS1 separator characters (NOT including %)
      const segments = processedBarcode
        .split(/[\(\)'\u00E7\u001D]/)
        .filter((s) => s.length > 0);

      if (hasApostrophe) {
        // BARCODE FORMAT (has ' separator)

        if (segments.length >= 5) {
          // Split segments, then reconstruct with %
          const part1 = segments[1]; // 2023
          const part2 = segments[2]; // 0048
          const part3 = segments[3]; // 0.01
          const part4 = segments[4]; // 20

          processedBarcode = `*${part1}-${part2}$${part3}%${part4}*`;
        } else if (segments.length === 4) {
          // Barcode without Operation: A5k(2021'7101ç7602(

          const part1 = segments[1]; // 2021
          const part2 = segments[2]; // 7101
          const part3 = segments[3]; // 7602

          processedBarcode = `*${part1}-${part2}$${part3}*`;
        } else {
          console.error(
            'Unexpected barcode format with apostrophe, segments:',
            segments
          );
          processedBarcode = `*${segments.slice(1).join('-')}*`;
        }
      } else {
        if (segments.length === 4) {
          // QR with Operation: A5k(1000.001ç403%20(

          const part1 = segments[1]; // 1000.001
          const part2 = segments[2]; // 403
          const part3 = segments[3]; // 20

          processedBarcode = `*${part1}$${part2}%${part3}*`;
        } else if (segments.length === 3) {
          // QR without Operation: A5k(1000.001ç403(
          const part1 = segments[1]; // 1000.001
          const part2 = segments[2]; // 403

          processedBarcode = `*${part1}$${part2}*`;
        } else if (segments.length === 2) {
          if (segments[0].match(/^[A-Za-z][0-9][a-z]$/)) {
            processedBarcode = `*${segments[1]}*`;
          } else {
            processedBarcode = `*${segments[0]}$${segments[1]}*`;
          }
        } else {
          const relevantSegments = segments.slice(1);
          processedBarcode = `*${relevantSegments.join('$')}*`;
        }
      }
    } else {
      // Examples: 2023-0048$0.01%20 or *2023-0048$0.01%20*

      const isSimpleBarcode = /^[A-Za-z0-9\-_\.\$%]+$/.test(processedBarcode);
      const isShortCode = processedBarcode.length < 50;

      if (isSimpleBarcode && isShortCode && !processedBarcode.startsWith('*')) {
        processedBarcode = '*' + processedBarcode + '*';
      } else if (
        processedBarcode.startsWith('*') &&
        processedBarcode.endsWith('*')
      ) {
      } else {
        console.error('Invalid barcode format:', processedBarcode);
        return throwError(
          () => new Error('Invalid barcode format: not enclosed in asterisks')
        );
      }
    }
    barcode.barcode = processedBarcode;

    return this.http.post<any>(
      AppConfig.settings.backend.url + BARCODE_ENDPOINT,
      barcode
    );
  }
}
